import { PlusIcon } from '@heroicons/react/16/solid';
import { FC } from 'react';

export const LeftPanels: FC = () => {
  return (
    <div id="left-panels" className="resizablePanelContainer left">
      <div id="tree_library" className="resizablePanel tree-view">
        <form id="tl_search">
          <div className="tree-title">
            <button className="title-prefix-icon tree-title-button" type="button"><i className="fe icon-chevrons-up"></i></button>
            <span className="tree-title-text"></span>
            <button className="form-button square" type="button"><PlusIcon /></button>
          </div>
          <div>
            <i className="fe icon-search input-prefix-icon"></i>
            <i className="fe icon-x input-suffix-icon clear-button"></i>
            <input type="search" id="tl_q" className="form-component v-marginal search"/>
          </div>
        </form>
        <div id="tl_container" className="tree-container">
        </div>
        <div id="tl_search_status" aria-live="polite" aria-atomic="true" className="sr-only"></div>
      </div>
      <div id="tree_member" className="resizablePanel tree-view">
        <form id="tm_search">
          <div className="tree-title">
            <button className="title-prefix-icon tree-title-button" type="button"><i className="fe icon-chevrons-up"></i></button>
            <span className="tree-title-text"></span>
            <button className="form-button square" type="button"><PlusIcon /></button>
          </div>
          <div>
            <i className="fe icon-search input-prefix-icon"></i>
            <i className="fe icon-x input-suffix-icon clear-button"></i>
            <input type="search" id="tm_q" className="form-component v-marginal search"/>
          </div>
        </form>
        <div id="tm_container" className="tree-container"></div>
        <div id="tm_search_status" aria-live="polite" aria-atomic="true" className="sr-only"></div>
      </div>
    </div>
  );
};
